import { getUser } from "@utils";
import Base from "./base";

export default class CryptoPayment extends Base {
	getAvailableBonuses(newStep) {
		const { selectedDeposit } = this.props,
			{ stake, selectedCurrency } = this.state;
		let dataToSend = {
			amount: {
				value: stake,
				currency: selectedCurrency,
			},
			paymentMethod: selectedDeposit.id,
			username: getUser().username,
		};
		this.props.externalFunc.getFilteredBonuses(
			dataToSend,
			() => {
				this.setState({ currentStep: newStep });
			},
			() => {
				this.onSelectBonusClaim.bind(this, false);
				this.setState({ currentStep: newStep + 1 });
				this.goForward(newStep);
			}
		);
	}

	makeExternalPayment(newStep) {
		const { stake, selectedCurrency } = this.state;
		const { selectedDeposit } = this.props;
		let payload = {
			sessionId: getUser().sessionId,
			amount: this.formatNumberDepositAmount(stake),
			currency: selectedCurrency,
			language: this.getActiveLanguageCode(),
			cryptoCurrencyType: selectedDeposit.cryptoCurrency
				? selectedDeposit.cryptoCurrency
				: "BTC",
		};
		this.props.externalFunc.depositCryptoPayment(payload, (data) => {
			this.setState({
				externalUrl: data.redirect_url,
				currentStep: newStep,
			});
		});
	}

	makeExternalPaymentWithBonus(newStep, bonusId) {
		const { stake, selectedCurrency } = this.state;
		const { selectedDeposit } = this.props;
		let payload = {
			sessionId: getUser().sessionId,
			amount: this.formatNumberDepositAmount(stake),
			currency: selectedCurrency,
			language: this.getActiveLanguageCode(),
			claimsBonus: true,
			bonusId: bonusId,
			cryptoCurrencyType: selectedDeposit.cryptoCurrency
				? selectedDeposit.cryptoCurrency
				: "BTC",
		};
		this.props.externalFunc.depositCryptoPayment(payload, (data) => {
			this.setState({
				externalUrl: data.redirect_url,
				currentStep: newStep,
			});
		});
	}
}
